import { render, staticRenderFns } from "./MainContentPage.vue?vue&type=template&id=2816d31e&scoped=true"
import script from "./MainContentPage.vue?vue&type=script&lang=js"
export * from "./MainContentPage.vue?vue&type=script&lang=js"
import style0 from "./MainContentPage.vue?vue&type=style&index=0&id=2816d31e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816d31e",
  null
  
)

export default component.exports